/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPrivacyRequestsForBackfill} from '../api'

export const useMutationCreatePrivacyRequestsForBackfill = createReactQueryMutationHook('createPrivacyRequestsForBackfill', createPrivacyRequestsForBackfill)
